<template>
  <div>
    <div class="title">
      <h3 class="left">Edition des informations générales</h3>
    </div>

    <div class="col-sm-12">
      <form class="form-horizontal" role="form">

        <div class="form-group">

          <label class="col-sm-3 control-label">Forme juridique</label>
          <div class="col-sm-9">
            <select class="full-width form-control dropdown-select">
              <option value="" disabled selected></option>
              <option value="AK">decoded_legal_form</option>
            </select>
          </div>

          <label for="name" class="col-sm-3 control-label">Nom de l'entreprise</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="name" placeholder="Nom de l'entreprise"
                   name="name">
          </div>

          <label for="initials" class="col-sm-3 control-label">Sigle</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="initials" placeholder="Sigle" name="initials">
          </div>

          <label for="trade_name" class="col-sm-3 control-label">Marque</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="trade_name" placeholder="Marque" name="trade_name">
          </div>

          <label class="col-sm-3 control-label">Entité</label>
          <div class="col-sm-9">
            <select class="full-width form-control dropdown-select">
              <option value="" disabled selected></option>
              <option value="AK">entity</option>
            </select>
          </div>

          <label class="col-sm-3 control-label">Vigilance</label>
          <div class="col-sm-9">
            <div class="radio radio-success">
              <input type="radio" value="green" name="decoded_vigilance_status" id="green" checked>
              <label for="green">Vert</label>
              <input type="radio" value="orange" name="decoded_vigilance_status" id="orange">
              <label for="orange">Orange</label>
              <input type="radio" value="red" name="decoded_vigilance_status" id="red">
              <label for="red">Rouge</label>
            </div>
          </div>

          <label for="decoded_type" class="col-sm-3 control-label">Status</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="decoded_type" placeholder="Status" name="decoded_type">
          </div>

          <label for="state" class="col-sm-3 control-label">État</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="state" placeholder="État" name="state" value="contentieux">
          </div>

          <label for="activity" class="col-sm-3 control-label">Activité</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="activity" placeholder="Activité" name="activity">
          </div>

          <label for="naf" class="col-sm-3 control-label">Code NAF</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="naf" placeholder="Code NAF" name="naf">
          </div>

          <label for="siret" class="col-sm-3 control-label">SIRET</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="siret" placeholder="SIRET" name="siret">
          </div>

          <label class="col-sm-3 control-label">Facture électronique</label>
          <div class="col-sm-9">
            <div class="radio radio-success">
              <input type="radio" value="yes" name="electronic-billing" id="yes" checked>
              <label for="yes">Oui</label>
              <input type="radio" value="no" name="electronic-billing" id="no">
              <label for="no">Non</label>
            </div>
          </div>

          <button class="btn btn-sm pull-right btn-success m-t-20 m-r-15">Valider</button>
          <button class="btn btn-sm pull-right btn-white m-t-20 m-r-15" @click.prevent="goBack">Annuler</button>
        </div>
        <!--<div class="form-group">
          <label class="col-sm-3 control-label">Your gender</label>
          <div class="col-sm-9">
            <div class="radio radio-success">
              <input type="radio" value="male" name="optionyes" id="male" aria-invalid="false">
              <label for="male">Male</label>
              <input type="radio" checked="checked" value="female" name="optionyes" id="female" aria-invalid="false">
              <label for="female">Female</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">Work</label>
          <div class="col-sm-9">
            <p>Have you Worked at page Inc. before, Or joined the Pages Supirior Club?</p>
            <p class="hint-text small">If yes State which Place, if yes note date and Job CODE /
              Membership Number</p>
            <div class="row">
              <div class="col-sm-5">
                <input type="text" class="form-control" required="" aria-required="true">
              </div>
              <div class="col-sm-5 sm-m-t-10">
                <input type="text" placeholder="Code/Number" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="position" class="col-sm-3 control-label">Position applying for</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="position" placeholder="Designation" required="" aria-required="true">
          </div>
        </div>
        <div class="form-group">
          <label for="name" class="col-sm-3 control-label">Description</label>
          <div class="col-sm-9">
            <textarea class="form-control" id="name" placeholder="Briefly Describe your Abilities"></textarea>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-sm-3">
            <p>I hereby certify that the information above is true and accurate. </p>
          </div>
          <div class="col-sm-9">
            <button class="btn btn-success" type="submit">Submit</button>
            <button class="btn btn-default"><i class="pg-close"></i> Clear</button>
          </div>
        </div>-->
      </form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .col-sm-9, .col-sm-3 {
    margin-top: 15px;
  }
</style>

<script type="text/babel">
  import customerMixin from 'mixins/customer'
  import { mapActions } from 'vuex'

  export default {

    name: 'EditGeneral',

    mounted () {
      $('.dropdown-select').select2({
        minimumResultsForSearch: -1
      })
    },

    methods: {
      goBack () {
        //this.$store.commit('FORM_ERROR', {})
        this.$emit('cancel-edit')
        // this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Edit/Customer/InformationsContent/EditGeneral.vue